import React, { useContext } from 'react';
import { SurveyPageContext } from '../../context/SurveyPageContext';
import QuestionInterface from '../../../interfaces/question';
import QuestionFactory from '../utils/questionFactory';

import styles from './Question.module.css';
import { QuestionType } from '../../../interfaces/questionType';
import ConditionalQuestion from '../ConditionalQuestion/ConditionalQuestion';

interface QuestionProps {
  question: QuestionInterface;
}

const Question: React.FunctionComponent<QuestionProps> = ({ question }) => {
  const questionType = question.type;
  const isRadioColor = QuestionType.RADIO_COLOR === questionType;
  const radioColorStyles = isRadioColor ? styles.radioColorQuestion : '';
  const { conditionalQuestionIds } = useContext(SurveyPageContext);
  const conditionalQuestionId = conditionalQuestionIds.get(question.id);

  return (
    <div className={`${styles.questionContainer} ${radioColorStyles}`}>
      <div className={styles.questionLabelContainer}>
        <p className={styles.questionLabel}>{question.value}</p>
        {question.caption && <p className={styles.questionSubLabel}>{question.caption}</p>}
      </div>
      <QuestionFactory question={question} />
      {question.disclaimer && <p className={styles.questionDisclaimer}>{question.disclaimer}</p>}
      {conditionalQuestionId &&
        conditionalQuestionId.length > 0 &&
        conditionalQuestionId.map((c) => <ConditionalQuestion conditionalQuestionId={c} />)}
    </div>
  );
};

Question.displayName = 'Question';

export default Question;
